import React from "react";
import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { baseurl } from "./constant";
const ChangePassword = () => {
  const [opw, setOpw] = useState();
  const [npw, setNpw] = useState();
  const [cpw, setCpw] = useState();
  const [data, setData] = useState();

  const navigate = useNavigate();

  const token = localStorage.getItem("authToken");
  const setpassword = async () => {
    const result = await axios.post(baseurl + "updatePasswordAuth", {
      token: token,
      opw: opw,
      npw: npw,
      cpw: cpw,
    });
    setData(result.data);

    if (result.data.status == 1) {
      localStorage.removeItem("authToken");
      navigate("/login");
    }
  };

  return (
    <div>
      <div>
        {data ? (
          <h5
            style={{
              backgroundColor: "#fadbd8",
              color: "#78261f",
              borderBlockColor: "#78261f",
            }}
          >
            {data.message}
          </h5>
        ) : (
          ""
        )}
      </div>
      <div className="card shadow ">
        <div className="card-header py-3">
          <div className="row">
            <div className="col-sm-6">
              <h4>
                <b>Update Password</b>
              </h4>
            </div>

            <div className="col-sm-6  text-right">
              {/* <button
                onclick="window.history.back()"
                className="btn btn-primary"
              >
                <i className="fa fa-arrow-left"> Back</i>
              </button> */}
            </div>
          </div>
        </div>
        <div className="card-body">
          <form
            id="admin_profile"
            enctype="multipart/form-data"
            method="post"
            accept-charset="utf-8"
          />
          <input type="hidden" name="method" value="post" />
          <input type="hidden" value="https://www.payol.in/" id="siteUrl" />
          <div className="row">
            <div className="col-sm-3">
              <div className="form-group">
                <label>
                  <b>Old Password*</b>
                </label>
                <input
                  type="password"
                  className="form-control"
                  name="opw"
                  id="opw"
                  placeholder="Old Password"
                  value={opw}
                  onChange={(e) => setOpw(e.target.value)}
                />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="form-group">
                <label>
                  <b>New Password*</b>
                </label>
                <input
                  type="password"
                  className="form-control"
                  name="npw"
                  id="npw"
                  placeholder="New Password"
                  value={npw}
                  onChange={(e) => setNpw(e.target.value)}
                />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="form-group">
                <label>
                  <b>Confirm New Password*</b>
                </label>
                <input
                  type="password"
                  className="form-control"
                  name="cpw"
                  id="cpw"
                  placeholder="Confirm New Password"
                  value={cpw}
                  onChange={(e) => setCpw(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="card shadow">
            <div className="card-header py-3 text-right">
              <button
                type="submit"
                className="btn btn-success"
                onClick={setpassword}
              >
                Submit
              </button>
              {/* <button
                onclick="window.history.back()"
                type="button"
                className="btn btn-secondary"
              >
                Cancel
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
